import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  webhooks: [],
  rotas: [],
  filas: [],
  operadores: [],
  webhook: {},
  gruposDeRotas: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
